import { render, staticRenderFns } from "./leading-step.vue?vue&type=template&id=bfca370e&scoped=true"
import script from "./leading-step.vue?vue&type=script&setup=true&lang=ts"
export * from "./leading-step.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfca370e",
  null
  
)

export default component.exports